"use strict";

/**
 * 组件JS
 */
$(function () {
  // 搜索框ad
  comSearchFrom(); // yjy-tips

  yjyTips(); // fold-text 展开与折叠

  foldText();
  comWeuiTab(); // yjy-tab-suspension 切换效果

  yjyTabSuspension(); // 弹窗关闭

  yjyPopupClose(); // yjy-quantity-adjustment 数量调整器

  yjyQuantityAdjuster();
});
/* 搜索组件效果 */

function comSearchFrom() {
  // 清除
  $("body").on("click", ".js-yjy-search[useAssembly] .js-clear", function () {
    $(this).parent().find("input[type='search']").val("");
    $(this).hide();
  }); // 搜索框获取到焦点

  $("body").on("focus", ".js-yjy-search[useAssembly] input[type='search']", function () {
    $(this).parent().find(".js-clear").show();
  }); // 搜索框失去焦点

  $("body").on("blur", ".js-yjy-search[useAssembly] input[type='search']", function () {
    $(this).parent().find(".js-clear").hide();
  });
} // yjy-tips


function yjyTips() {
  // 关闭
  $("body").on("click", ".js-tips[useAssembly] .yjy-tips__close", function () {
    $(this).parents(".yjy-tips").remove();
  });
} // fold-text展开与折叠


function foldText() {
  $("body").on("click", ".js-fold-text[useAssembly] .yjy-fold-text__opr", function () {
    $(this).parents(".js-fold-text").toggleClass("yjy-fold-text--expend");
  });
} // weui-tab 切换效果


function comWeuiTab() {
  $("body").on("click", ".weui-tab[useAssembly] .weui-navbar__item", function () {
    var _$this = $(this);

    var _$tabRoot = $(_$this.parents(".weui-tab")[0]);

    var _$tabItems = _$tabRoot.find(".weui-tab__panel .weui-tab__content");

    _$this.addClass("weui-bar__item_on").siblings().removeClass("weui-bar__item_on");

    if (_$tabItems.length > 0) {
      var currentIndex = _$this.index();

      _$tabItems.removeClass("weui-tab__content--on").eq(currentIndex).addClass("weui-tab__content--on");
    }
  });
} // yjy-tab-suspension 切换效果


function yjyTabSuspension() {
  $("body").on("click", ".yjy-tab-suspension[useAssembly] .js-tab-suspension__menu", function () {
    var _$this = $(this);

    var _$currentTab = $(_$this.parents(".yjy-tab-suspension")[0]);

    _$this.toggleClass("is-active").siblings().removeClass("is-active");

    var _$contentItems = _$currentTab.find(".yjy-tab-suspension__bd");

    if (_$contentItems.length > 0) {
      var currentIndex = _$this.index();

      _$contentItems.eq(currentIndex).toggleClass("is-active").siblings().removeClass("is-active");

      var menuActiveNum = _$currentTab.find(".yjy-tab-suspension__bd.is-active").length;

      if (menuActiveNum > 0) {
        _$currentTab.find(".yjy-tab-suspension__mask").fadeIn();

        $(".yjy-layout").css("overflow", "hidden");
      } else {
        _$currentTab.find(".yjy-tab-suspension__mask").fadeOut();

        $(".yjy-layout").css("overflow", "auto");
      }
    }
  });
  $("body").on("click", ".yjy-tab-suspension[useAssembly] .yjy-tab-suspension__mask", function () {
    var _$this = $(this);

    var _$currentTab = $(_$this.parents(".yjy-tab-suspension")[0]);

    _$currentTab.find(".yjy-tab-suspension__bd").removeClass("is-active");

    _$currentTab.find(".yjy-tab-suspension__menu").removeClass("is-active");

    _$this.fadeToggle();

    $(".yjy-layout").css("overflow", "auto");
  });
} // yjy-quantity-adjustment 数量调整器


function yjyQuantityAdjuster() {
  $("body").on("click", ".yjy-quantityAdjustment[useAssembly] .yjy-quantityAdjustment__decrease", function () {
    var _$this = $(this);

    var _$number = _$this.parent(".yjy-quantityAdjustment").find(".yjy-quantityAdjustment__number");

    var oldNumber = parseInt(_$number.val());
    var newNumber = oldNumber - 1;

    if (newNumber < 1) {
      _$number.hide();

      _$this.hide();

      _$number.val(newNumber);
    } else {
      _$number.show();

      _$this.show();

      _$number.val(newNumber);
    }
  });
  $("body").on("click", ".yjy-quantityAdjustment[useAssembly] .yjy-quantityAdjustment__increase", function () {
    var _$this = $(this);

    var _$number = _$this.parent(".yjy-quantityAdjustment").find(".yjy-quantityAdjustment__number");

    var _$decrease = _$this.parent(".yjy-quantityAdjustment").find(".yjy-quantityAdjustment__decrease");

    var oldNumber = parseInt(_$number.val());
    var newNumber = oldNumber + 1;

    if (newNumber < 1) {
      _$number.hide();

      _$decrease.hide();

      _$number.val(newNumber);
    } else {
      _$number.show();

      _$decrease.show();

      _$number.val(newNumber);
    }
  });
} // 弹窗关闭


function yjyPopupClose() {
  $("body").on("click", ".yjy-popup-page", function (event) {
    var _$this = $(this);

    var _$container = _$this.find(".yjy-popup-page__container");

    _$container.animate({
      bottom: "-80%"
    }, 300);

    setTimeout(function () {
      _$this.hide();
    }, 300);
  });
  $("body").on("click", ".yjy-popup-page__container", function (event) {
    event.stopPropagation();
  });
}